// Generated by ReScript, PLEASE EDIT WITH CARE


var development = "development";

var staging = "staging";

var production = "production";

var prod = "prod";

export {
  development ,
  staging ,
  production ,
  prod ,
}
/* No side effect */
